<template>
  <main>

    <div class="path">
      <i class="el-icon-caret-right"></i>资源管理
      <i class="el-icon-arrow-right"></i>&nbsp;资源包管理
    </div>

    <br>
    <div class="content_wrapper" :style="'width:' + (wrapperWidth*navCollapse) + 'vw;'">
      <el-form :inline="true" label-width="120px">
        <div class="item-wrapper">
          <div class="item-content clearfix">

            <el-form-item label="资源类型" style="margin-bottom: 0px;">
              <el-select v-model="value" placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="购买日期" class="query-item">
              <el-date-picker
                v-model="createTime"
                value-format="yyyy-MM-dd"
                type="daterange"
                align="right"
                :editable='false'
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions">
              </el-date-picker>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="handleQuery">查 询</el-button>
            </el-form-item>

            <el-form-item>
              <el-button icon="el-icon-refresh-left" @click="handleReset">重 置</el-button>
            </el-form-item>

          </div>

        </div>
      </el-form>
    </div>

    <section class="content_wrapper" :style="'width:' + (wrapperWidth*navCollapse) + 'vw;'">

      <el-table
        :data="tableData.list"
        v-loading="loading"
        stripe
        :style="'width:' + (wrapperWidth*navCollapse) + 'vw;'">
        <el-table-column label="序号" :width="60*navCollapse">
          <template slot-scope="scope">
            {{ (currentPage-1) * pageSize + scope.$index + 1}}
          </template>
        </el-table-column>
        <el-table-column
          prop="no"
          label="资源包编号"
          :width="110*navCollapse">
        </el-table-column>

        <el-table-column
          prop="res.name"
          label="资源包"
          :width="110*navCollapse">
        </el-table-column>

        <el-table-column
          prop="res.spec"
          label="规格"
          :width="330*navCollapse">
        </el-table-column>

        <el-table-column
          prop=""
          label="设备数"
          :width="110*navCollapse">
          <template slot-scope="scope">
            {{formatNumber(scope.row.deviceAmount)}}
          </template>
        </el-table-column>

        <el-table-column
          prop=""
          label="使用情况"
          :width="250*navCollapse">
          <template slot-scope="scope">
            <el-progress :text-inside="true" :stroke-width="16" :percentage="formattedPrice(scope.row.consumedTokens/scope.row.totalTokens)"></el-progress>
          </template>
        </el-table-column>

        <el-table-column
          prop="createTime"
          label="购买时间"
          :width="165*navCollapse">
        </el-table-column>

        <el-table-column
          prop="endTime"
          label="失效时间"
          :width="120*navCollapse">
        </el-table-column>

        <el-table-column
          label="操作">
          <template slot-scope="scope">
            <el-button @click="" type="text" size="small" @click="openRepurchaseDialog(scope.row)" >续购</el-button>
            <el-button @click="" type="text" size="small" @click="openUpgradeDialog(scope.row)">升级</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next"
        :total="total">
      </el-pagination>
    </section>

    <el-dialog v-if="repurchaseProduct.res" title="续购" :visible.sync="dialogRepurchaseVisible" width="64%">
      <div class="tip-ol-box">
        <ul type="disc" class="tip-ol">
          <li>您可以随时取消自动续购，续购成功或失败您都会收到我们的消息提醒</li>
          <li>续购的资源包其规格与当前资源包保持一致</li>
          <li>资源包续购价格为该资源包原刊例价，详情请查看计费说明</li>
        </ul>
      </div>
      <br>

      <div style="margin: 10px 0px; font-size: 16px; font-weight: bold;">当前套餐</div>
      <div class="my-table" style="width: 60vw; ">
        <div>
          <div class="table-header">
            <span class="table-cell" style="width: 6vw;">资源包</span>
            <span class="table-cell" style="width: 20vw;">规格</span>
            <span class="table-cell" style="width: 6vw;">设备数</span>
            <span class="table-cell" style="width: 6vw;">有效期</span>
            <span class="table-cell" style="width: 7vw;">到期时间</span>
            <span class="table-cell" style="width: 6vw;">单价（元）</span>
            <span class="table-cell" style="width: 7vw;">总价（元）</span>
          </div>
          <hr style="margin-bottom: 0px; margin-top: 0px;">
        </div>

        <div>
          <div class="table-row">
            <span class="table-cell" style="width: 6vw;">{{repurchaseProduct.res.name}}</span>
            <span class="table-cell" style="width: 20vw;">{{repurchaseProduct.res.spec}}</span>
            <span class="table-cell" style="width: 6vw; color: #666;">{{repurchaseProduct.deviceAmount}}</span>
            <span class="table-cell" style="width: 6vw;">1年</span>
            <span class="table-cell" style="width: 7vw;">2025-12-31</span>
            <span class="table-cell" style="width: 6vw;">{{formattedPrice(repurchaseProduct.res.realPrice)}}</span>
            <span class="table-cell" style="width: 7vw; color: #EF6234; font-weight: bold;">
              {{formatNumber(formattedPrice(repurchaseProduct.res.realPrice*repurchaseProduct.deviceAmount))}}
            </span>

          </div>
          <hr style="margin-bottom: 0px; margin-top: 0px;" size=1 color="#ddd">

        </div>
      </div>

      <br>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogRepurchaseVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogRepurchaseVisible = false">购 买</el-button>
      </div>
    </el-dialog>

    <el-dialog title="套餐升级" :visible.sync="dialogUpgradeVisible" width="73%">

      <div class="tip-box">
        <div>
          <span style="font-size: 20px; color: #3888d7; font-weight: 800; padding-right: 6px;">|</span>
          <span style="font-size: 18px; font-weight: bold;">购买须知</span>
        </div>
        <div style="margin-top: 16px;">
          <span class="tip-tab">费用说明</span>
          <span class="tip-content">流量套餐允许在有效年度内升级配置，升配后的总量和费用均按月度平均后补齐。</span>
        </div>
        <div style="margin-top: 16px;">
          <span class="tip-tab">退订规则</span>
          <span class="tip-content">资源包购买后未使用，支持7天无理由退款。若购买后已使用，不支持退款及剩余次数冻结。</span>
        </div>
      </div>

      <div class="tip-box" style="margin-top: 40px;">
        <div>
          <span style="font-size: 20px; color: #3888d7; font-weight: 800; padding-right: 6px;">|</span>
          <span style="font-size: 18px; font-weight: bold;">配置选择</span>
        </div>
      </div>

      <div class="product-box">
        <div style="margin-top: 20px;">
          <span class="tip-label">资源类型</span>
          <el-select v-model="value" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>

        <div class="resource-box" style="margin-top: 20px;">
          <div class="tip-label">资源包</div>

          <div class="resource-package-box">
            <div class="resource-package-box-1">
              <div class="resource-package-box-2">
                <div class="resource-package-desc">
                  <div class="resource-package-title">Token数量：100万/设备，并发量：1000/qps </div>
                  <div class="resource-package-valid-date">有效期自购买之日一年内</div>
                </div>
                <div class="resource-package-price">{{ formattedPrice(product1Price) }}元</div>
              </div>
              <div class="resource-package-amount">
                <span><el-input-number @change="handleChange" v-model="deviceAmount1" :min="0" :step="10"></el-input-number></span>
                <span style="margin-left: 4px; color:#999; font-size: 13px;">个</span>
              </div>
            </div>

            <div class="resource-package-box-1">
              <div class="resource-package-box-2">
                <div class="resource-package-desc">
                  <div class="resource-package-title">Token数量：500万/设备，并发量：2000/qps </div>
                  <div class="resource-package-valid-date">有效期自购买之日一年内</div>
                </div>
                <div class="resource-package-price">{{ formattedPrice(product2Price) }}元</div>
              </div>
              <div class="resource-package-amount">
                <span><el-input-number @change="handleChange" v-model="deviceAmount2" :min="0" :step="10"></el-input-number></span>
                <span style="margin-left: 4px; color:#999; font-size: 13px;">个</span>
              </div>
            </div>

            <div class="resource-package-box-1">
              <div class="resource-package-box-2">
                <div class="resource-package-desc">
                  <div class="resource-package-title">Token数量：1000万/设备，并发量：5000/qps </div>
                  <div class="resource-package-valid-date">有效期自购买之日一年内</div>
                </div>
                <div class="resource-package-price">{{ formattedPrice(product3Price) }}元</div>
              </div>
              <div class="resource-package-amount">
                <span><el-input-number @change="handleChange" v-model="deviceAmount3" :min="0" :step="10"></el-input-number></span>
                <span style="margin-left: 4px; color:#999; font-size: 13px;">个</span>
              </div>
            </div>
          </div>
        </div>

        <div style="margin-top: 20px;">
          <span class="tip-label">协议条款</span>
          <span class="tip-label" style="width: 50vw;">
          <el-checkbox v-model="checked" style="color: #666; font-size: 14px;">我已阅读并同意</el-checkbox>
          <el-link type="primary" style="margin-top: -2px; font-size: 14px;">《大模型服务条款》</el-link>
        </span>
        </div>

      </div>


      <div class="pay-box">
        <span>结算费用</span>
        <span class="total-price">{{formattedPrice(totalPrice)}}元</span>
        <el-button type="primary" :disabled="!checked">立即购买</el-button>
        <el-button @click="dialogUpgradeVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </main>
</template>

<style>
  .el-table .success-cell {
    background: #F0F9EB;
    font-weight: bold;
  }
</style>

<script>
import {mapState} from 'vuex'
import {
  formatNumber
} from '@/common/utils.js'
import {
  reqPurchasedResourcePackages
} from '@/api'

export default {
  name: 'PurchasedResourcePackage2',

  data() {
    return {
      widthRatio: 1.0,

      tableData: {},
      loading: true,
      phone: '',
      name: '',
      createTime: '',
      currentPage: 1,
      total: 0,
      pageSize: 30,

      repurchaseProduct: {},
      dialogRepurchaseVisible: false,
      dialogUpgradeVisible: false,

      product1Price: 3,
      product2Price: 5,
      product3Price: 10,
      deviceAmount1: 0,
      deviceAmount2: 0,
      deviceAmount3: 0,
      totalPrice: 0,
      checked: false,

      options: [{
        value: '1',
        label: '标准资源包'
      }, {
        value: '2',
        label: '豪华资源包'
      }],
      value: '1',

      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
    }
  },

  async mounted () {
    await this.getPurchasedResourcePackages()

    // const result = await reqFindAllVideoClickHistory(this.phone, this.name, '', '', this.currentPage)
    // if (result.code === 0) {
    //   this.tableData = result.data
    //   this.loading = false
    //   this.total  = result.data.total
    //   this.pageSize  = result.data.pageSize
    // } else {
    //   this.$message.error('数据查询失败，错误信息: ' + result.message)
    // }
  },

  methods: {
    formatNumber (num) {
      return formatNumber(num)
    },

    async getPurchasedResourcePackages() {
      const result = await reqPurchasedResourcePackages()
      if (result.code === 0) {
        this.tableData = result.data
        this.loading = false
        this.total  = result.data.total
        this.pageSize  = result.data.pageSize
      } else {
        this.$message.error('数据查询失败，错误信息: ' + result.message)
      }
    },

    formattedPrice (price) {
      return parseFloat(parseFloat(price).toFixed(2)) // 保留两位小数
    },

    handleChange (value) {
      this.totalPrice = this.product1Price * this.deviceAmount1 +
        this.product2Price * this.deviceAmount2 +
        this.product3Price * this.deviceAmount3
    },

    openRepurchaseDialog (row) {
      this.dialogRepurchaseVisible = true
      this.repurchaseProduct = row
      console.log(row)
    },

    openUpgradeDialog (row) {
      this.dialogUpgradeVisible = true
      this.repurchaseProduct = row
    },

    async handleCurrentChange(val) {
    },

    handleQuery () {
      this.tableData = {}
      this.handleCurrentChange(1)
    },

    handleReset() {
      this.phone = ''
      this.name = ''
      this.createTime = ''
      this.handleQuery()
    },
  },

  computed: {
    ...mapState(['navCollapse', 'wrapperWidth']),
  }

}
</script>

<style scoped>

  main {
    display: flex;
    flex-direction: column;
  }

  .content_wrapper {
    width: 82vw;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 20px auto;
  }


  .tip-ol-box {
    background-color: rgba(96, 149, 242, 0.3);
    padding: 10px 0px;
  }

  .tip-ol {
    color: #0C129A;
    font-size: 12px;
    line-height: 24px;
  }


  .tip-box {
    display: flex;
    flex-direction: column;
  }

  .tip-tab {
    font-size: 13px;
    padding: 6px 10px;
    color: #666;
    background-color: rgba(243, 243, 243, 0.9);
    margin-right: 20px;
  }

  .tip-content {
    font-size: 14px;
    color: #666;
  }

  .product-box {
    display: flex;
    flex-direction: column;
  }

  .resource-box {
    display: flex;
    flex-direction: row;
  }

  .tip-label {
    font-size: 14px;
    color: #666;
    width: 7vw;
  }

  .resource-package-box {
    display: flex;
    flex-direction: column;
  }

  .resource-package-box-1 {
    display: flex;
    flex-direction: row;
    margin-bottom: 20px;
  }

  .resource-package-box-1:hover {
    border: solid 2px #409EFF;
  }

  .resource-package-box-2 {
    display: flex;
    flex-direction: row;
    width: 45vw;
    padding-left: 24px;
    padding-top: 24px;
    padding-bottom: 24px;
    border: solid 1px #999;
    border-right: dashed 1px #999;
  }

  .resource-package-desc {
    display: flex;
    flex-direction: column;
    width: 45vw;
  }

  .resource-package-title {
    font-size: 16px;
    font-weight: 500;
    line-height: 26px;
  }

  .resource-package-valid-date {
    font-size: 12px;
    color: #666;
    line-height: 26px;
  }

  .resource-package-price {
    display: flex;
    justify-content: right;
    padding-top: 4px;
    font-size: 18px;
    font-weight: bold;
    color: #EF6234;
    text-align: right;
    width: 5vw;
    padding-right: 25px;
  }

  .resource-package-amount {
    border-top: solid 1px #999;
    border-bottom: solid 1px #999;
    border-right: solid 1px #999;
    padding: 25px;
  }

  .pay-box {
    margin-top: 50px;
    width: 100%;
    height: 40px;
    display: flex;
    flex-direction: row;
    justify-content: right;
    align-items: end;
  }

  .total-price {
    margin-left: 16px;
    margin-right: 20px;
    font-size: 22px;
    font-weight: bold;
    color: #EF6234;
    text-align: right;
  }
</style>



// WEBPACK FOOTER //
// src/pages/CustomerCenter/PurchasedResourcePackage/PurchasedResourcePackage_c.vue